/**
 * FR-30: CSV-Export für Excel (deutsch) -- Semikolon, Dezimalkomma, UTF-8 mit BOM, CRLF.
 * Die Daten kommen aus denselben API-Antworten wie die Anzeige, die Sichtbarkeit (FR-29) ist
 * also schon serverseitig erzwungen.
 */

// Als Zeichencode, damit Formatierer daraus kein unsichtbares Literal machen.
const BOM = String.fromCharCode(0xfeff);

export type Cell = string | number | undefined | null;

/** Betrag in Cent als Excel-Zahl: ohne Tausenderpunkt, mit Komma, z. B. "-1234,56". */
export function csvAmount(cents: number): string {
  const sign = cents < 0 ? '-' : '';
  const abs = Math.abs(cents);
  return `${sign}${Math.floor(abs / 100)},${String(abs % 100).padStart(2, '0')}`;
}

export function csvDate(iso: string | undefined): string {
  return iso ? iso.split('-').reverse().join('.') : '';
}

/**
 * Ein Feld: Text, der wie eine Formel aussieht, bekommt ein Hochkomma (sonst führt Excel ihn
 * aus); Semikolon, Anführungszeichen und Zeilenumbrüche erzwingen Anführungszeichen.
 */
function field(value: Cell, isText: boolean): string {
  let s = value === undefined || value === null ? '' : String(value);
  if (isText && /^[=+\-@\t\r]/.test(s)) s = `'${s}`;
  return /[;"\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/**
 * Baut die Datei. `amountColumns` sind die Spaltenindizes, die bereits mit `csvAmount`
 * formatiert sind und deshalb nicht als Text behandelt werden.
 */
export function toCsv(header: string[], rows: Cell[][], amountColumns: number[] = []): string {
  const amounts = new Set(amountColumns);
  const line = (cells: Cell[]) => cells.map((c, i) => field(c, !amounts.has(i))).join(';');
  return BOM + [header, ...rows].map(line).join('\r\n') + '\r\n';
}

/** Löst den Download im Browser aus. */
export function downloadCsv(filename: string, content: string) {
  const url = URL.createObjectURL(new Blob([content], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
